'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var ConstantsService = function ConstantsService($filter, $http, $q, $rootScope, $sanitize) {
    var CAMPUS = [];
    var CODERS = [];
    var CODINGSTANDARDS = [];
    var DIVSANDSPECS = {};
    var HEALTHCAREFUND = [];
    var PATIENTCLASSIFICATION = [];
    var QUERYTEMPLATE = {};
    var lookups = { atsi: [], los: [], worklists: [] };

    /**
     * Get the query template names with their IDs
     */
    var getQueryTemplateData = function getQueryTemplateData() {
        var deferred = $q.defer();
        if (!QUERYTEMPLATE.queryTemplateId) {
            $http.get(WEBSERVICEURL + '/dataagility/api/service.querytemplate').then(function successCallback(response) {
                QUERYTEMPLATE = $filter('orderBy')(response.data, 'queryTemplateName');
                deferred.resolve(QUERYTEMPLATE);
            }, function errorCallback(response) {});
        } else {
            deferred.resolve(QUERYTEMPLATE);
        }
        return deferred.promise;
    };

    /**
     * Get the list of campuses
     */
    var campusData = function campusData() {
        var deferred = $q.defer();
        if (CAMPUS.length === 0) {
            $http.defaults.headers.common['Authorization'] = 'Bearer ' + $rootScope.globals.currentUser.token;
            $http.get(WEBSERVICEURL + '/dataagility/api/service.episodeaudit/campus').then(function successCallback(response) {
                angular.forEach(response.data, function (value, key) {
                    var sterilizedCampus = $sanitize(value['campus']).replace(/&amp;/g, '&');
                    if (sterilizedCampus && CAMPUS.indexOf(sterilizedCampus) === -1) {
                        CAMPUS.push(sterilizedCampus);
                    }
                });
                deferred.resolve(CAMPUS);
            }, function errorCallback(response) {
                if (response.status === 401) {
                    window.location.replace(window.location.origin + '/login?logout=true');
                }
            });
        } else {
            deferred.resolve(CAMPUS);
        }
        return deferred.promise;
    };

    /**
     * Get the list of coders
     */
    var coderData = function coderData() {
        var deferred = $q.defer();
        if (CODERS.length === 0) {
            $http.defaults.headers.common['Authorization'] = 'Bearer ' + $rootScope.globals.currentUser.token;
            $http.get(WEBSERVICEURL + '/dataagility/api/service.refcode/query?domain=CODER').then(function successCallback(response) {
                angular.forEach(response.data, function (value, key) {
                    var sterilizedDescription = $sanitize(value['description']).replace(/&amp;/g, '&');
                    if (sterilizedDescription && CODERS.indexOf(sterilizedDescription) === -1) {
                        CODERS.push(sterilizedDescription);
                    }
                });
                deferred.resolve(CODERS);
            }, function errorCallback(response) {
                if (response.status === 401) {
                    window.location.replace(window.location.origin + '/login?logout=true');
                }
            });
        } else {
            deferred.resolve(CODERS);
        }
        return deferred.promise;
    };

    /**
     * Combined function to fetch and populate the divisions and specialties
     */
    var getDivisionAndSpecialtyData = function getDivisionAndSpecialtyData() {
        var deferred = $q.defer();
        if (!DIVSANDSPECS.specialties) {
            $http.defaults.headers.common['Authorization'] = 'Bearer ' + $rootScope.globals.currentUser.token;
            $http.get(WEBSERVICEURL + '/dataagility/api/service.refcode/query?domain=SPECIAL').then(function successCallback(response) {
                var divisionsAndSpecialties = { divisions: [], specialties: [] };
                angular.forEach(response.data, function (value, key) {
                    var sterilizedGroupName = $sanitize(value['groupName']).replace(/&amp;/g, '&');
                    if (sterilizedGroupName && divisionsAndSpecialties.divisions.indexOf(sterilizedGroupName) === -1) {
                        divisionsAndSpecialties.divisions.push(sterilizedGroupName);
                    }
                    // angular-sanitize is causing the HTML representation of ampersands to be passed to
                    // encodeURIComponent(), which is breaking select lists. Maybe we can just sanitise
                    // before saving to the DB and trust what we pull out of it, but Mike's on holidays,
                    // so replace() is my solution for now.
                    var sterilizedDescription = $sanitize(value['description']).replace(/&amp;/g, '&');
                    if (sterilizedDescription && divisionsAndSpecialties.specialties.indexOf(sterilizedDescription) === -1) {
                        divisionsAndSpecialties.specialties.push(sterilizedDescription);
                    }
                });
                DIVSANDSPECS = divisionsAndSpecialties;
                deferred.resolve(DIVSANDSPECS);
            }, function errorCallback(response) {
                if (response.status === 401) {
                    window.location.replace(window.location.origin + '/login?logout=true');
                }
            });
        } else {
            deferred.resolve(DIVSANDSPECS);
        }
        return deferred.promise;
    };

    /**
     * Get the list of health care funds
     */
    var healthCareFundData = function healthCareFundData() {
        var deferred = $q.defer();
        if (HEALTHCAREFUND.length === 0) {
            $http.defaults.headers.common['Authorization'] = 'Bearer ' + $rootScope.globals.currentUser.token;
            $http.get(WEBSERVICEURL + '/dataagility/api/service.columntabledistinctvaluelookup/healthcarefunds').then(function successCallback(response) {
                angular.forEach(response.data, function (value, key) {
                    var sterilizedHcf = $sanitize(value['healthCareFund']).replace(/&amp;/g, '&');
                    if (sterilizedHcf && HEALTHCAREFUND.indexOf(sterilizedHcf) === -1 && typeof value.healthCareFund !== 'undefined' && value.healthCareFund !== 'undefined') {
                        HEALTHCAREFUND.push(sterilizedHcf);
                    }
                });
                deferred.resolve(HEALTHCAREFUND);
            }, function errorCallback(response) {
                if (response.status === 401) {
                    window.location.replace(window.location.origin + '/login?logout=true');
                }
            });
        } else {
            deferred.resolve(HEALTHCAREFUND);
        }
        return deferred.promise;
    };

    /**
     * Get the list of patient classifications
     */
    var patientClassificationData = function patientClassificationData() {
        var deferred = $q.defer();
        if (PATIENTCLASSIFICATION.length === 0) {
            $http.defaults.headers.common['Authorization'] = 'Bearer ' + $rootScope.globals.currentUser.token;
            $http.get(WEBSERVICEURL + '/dataagility/api/service.columntabledistinctvaluelookup/patientclassifications').then(function successCallback(response) {
                angular.forEach(response.data, function (value, key) {
                    var sterilizedPc = $sanitize(value['patientClassification']).replace(/&amp;/g, '&');
                    if (sterilizedPc && PATIENTCLASSIFICATION.indexOf(sterilizedPc) === -1) {
                        PATIENTCLASSIFICATION.push(sterilizedPc);
                    }
                });
                deferred.resolve(PATIENTCLASSIFICATION);
            }, function errorCallback(response) {
                if (response.status === 401) {
                    window.location.replace(window.location.origin + '/login?logout=true');
                }
            });
        } else {
            deferred.resolve(PATIENTCLASSIFICATION);
        }
        return deferred.promise;
    };

    /**
     * Get the list of coding standards
     */
    var codingStandardsData = function codingStandardsData() {
        var deferred = $q.defer();
        if (CODINGSTANDARDS.length === 0) {
            $http.defaults.headers.common['Authorization'] = 'Bearer ' + $rootScope.globals.currentUser.token;
            $http.get(WEBSERVICEURL + '/dataagility/api/service.refcode/query?domain=CODINGSTANDARDS').then(function successCallback(response) {
                angular.forEach(response.data, function (value, key) {
                    var sterilizedDescription = $sanitize(value['description']).replace(/&amp;/g, '&');
                    if (CODINGSTANDARDS.indexOf(sterilizedDescription) === -1) {
                        CODINGSTANDARDS.push(sterilizedDescription);
                    }
                });
                deferred.resolve(CODINGSTANDARDS);
            }, function errorCallback(response) {
                if (response.status === 401) {
                    window.location.replace(window.location.origin + '/login?logout=true');
                }
            });
        } else {
            deferred.resolve(CODINGSTANDARDS);
        }
        return deferred.promise;
    };

    /**
     * Get the list of lookups via it's refCodeDomain
     */
    var lookupsData = function lookupsData(userId, refCode) {
        var deferred = $q.defer();
        if (lookups[refCode].length === 0) {
            $http.defaults.headers.common['Authorization'] = 'Bearer ' + $rootScope.globals.currentUser.token;
            $http.get(WEBSERVICEURL + '/dataagility/api/service.episodeauditlookupvalues/userId/' + userId + '/getLookups?' + refCode + '=true').then(function successCallback(response) {
                lookups[refCode] = response.data[refCode];
                deferred.resolve(lookups[refCode]);
            }, function errorCallback(response) {
                if (response.status === 401) {
                    window.location.replace(window.location.origin + '/login?logout=true');
                }
            });
        } else {
            deferred.resolve(lookups[refCode]);
        }
        return deferred.promise;
    };

    return { campusData: campusData, coderData: coderData, getDivisionAndSpecialtyData: getDivisionAndSpecialtyData, healthCareFundData: healthCareFundData, lookupsData: lookupsData,
        patientClassificationData: patientClassificationData, codingStandardsData: codingStandardsData, getQueryTemplateData: getQueryTemplateData };
};

exports.default = ConstantsService;


// WEBPACK FOOTER //
// ./client/app/common/services/constant.service.js